import Icon from '../../../components/AppIcon';

const AvailabilitySection = ({ availability }) => {
  // Parse availability string or use default schedule
  const parseAvailability = (availabilityText) => {
    // Default weekly schedule
    const defaultSchedule = [
      { day: 'Monday', available: true, hours: '9:00 AM - 5:00 PM' },
      { day: 'Tuesday', available: true, hours: '9:00 AM - 5:00 PM' },
      { day: 'Wednesday', available: true, hours: '9:00 AM - 5:00 PM' },
      { day: 'Thursday', available: true, hours: '9:00 AM - 5:00 PM' },
      { day: 'Friday', available: true, hours: '9:00 AM - 5:00 PM' },
      { day: 'Saturday', available: false, hours: 'Not available' },
      { day: 'Sunday', available: false, hours: 'Not available' }
    ];

    // If availability text indicates full-time or flexible, return default
    if (availabilityText?.toLowerCase()?.includes('full-time') || 
        availabilityText?.toLowerCase()?.includes('flexible')) {
      return defaultSchedule;
    }

    return defaultSchedule;
  };

  const schedule = parseAvailability(availability);

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-6">
      <h2 className="text-lg font-bold text-foreground mb-4 flex items-center gap-2">
        <Icon name="Calendar" className="w-5 h-5 text-primary" />
        Availability
      </h2>

      {/* Availability Summary */}
      <div className="mb-4 p-3 bg-primary/5 rounded-lg">
        <p className="text-sm font-medium text-foreground">{availability}</p>
      </div>

      {/* Weekly Schedule */}
      <div className="space-y-2">
        {schedule?.map((slot, index) => (
          <div 
            key={index}
            className={`flex items-center justify-between p-3 rounded-lg ${
              slot?.available 
                ? 'bg-success/5 border border-success/20' :'bg-muted/50 border border-border'
            }`}
          >
            <div className="flex items-center gap-3">
              <div className={`w-2 h-2 rounded-full ${
                slot?.available ? 'bg-success' : 'bg-muted-foreground'
              }`} />
              <span className={`font-medium ${
                slot?.available ? 'text-foreground' : 'text-muted-foreground'
              }`}>
                {slot?.day}
              </span>
            </div>
            <span className={`text-sm ${
              slot?.available ? 'text-foreground' : 'text-muted-foreground'
            }`}>
              {slot?.hours}
            </span>
          </div>
        ))}
      </div>

      {/* Quick Info */}
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-start gap-2 text-sm text-muted-foreground">
          <Icon name="Info" className="w-4 h-4 mt-0.5 flex-shrink-0" />
          <p>Schedule may vary based on project requirements. Contact worker for specific availability.</p>
        </div>
      </div>
    </div>
  );
};

export default AvailabilitySection;